<template>
  <input-container  
    :id="inputId"
    :inputFieldId="`input-field-id-${name}`"
    :label="label" :assistive="assistive"
    :label-class="labelClass"
    :tooltip-text="tooltipText"
    :no-assistive="noAssistive"
    :max="max" :body-id="bodyId"
    :count="input ? input.length : 0"
    :char-counter="charCounter"
    :classes="classes"
    :class="{ focused, disabled, invalid, readonly }"
    :bodyClass="bodyClass"
    :tooltip-custom-style="tooltipCustomStyle"
    >

    <template #container>
      <slot name="icon-left"></slot>

      <InputComponent
        ref="input"
        :type="inputType"
        :step="step"
        :class="inputClass"
        :placeholder="placeholder"
        :id="`input-field-id-${name}`"
        :name="name"
        v-model="input"
        @focus="focus"
        @blur="blur"
        @backspace="$emit('backspace')"
        @enter="$emit('enter')"
        :disabled="disabled"
        :delay="delay"
        :max="max"
        :sanitize="sanitize"
        :is-readonly="readonly"
        :autofocus="autofocus"
        />
        
      <slot name="icon-right"></slot>
      
      <button type="button" v-if="showCleanButton" class="flex items-center justify-center w-8 h-8 rounded-md transition-all duration-300 cursor-pointer bg-primary-500 hover:bg-primary-600 mr-4" @click="clear">
        <UIcon name="i-pkg-action-close" class="size-4 text-white" />
      </button>
      
      <slot name="enhancer-label" :enhancerLabel="enhancerLabel">
        <div class="h-full flex items-center" @click.prevent>
          <span class="font-manrope mr-3 md:mr-4 leading-6 text-base font-medium" v-if="enhancerLabel">{{ enhancerLabel }}</span>
        </div>
      </slot>

      <slot name="tooltip" v-if="tooltip">
        <b-tooltip :target="inputId" triggers="hover">
          {{ tooltip }}
        </b-tooltip>
      </slot>
    </template>
  </input-container>
</template>

<script>
import InputContainer from './input-container.vue';
import InputComponent from './input-component.vue';

export default {
  components: {
    InputContainer,
    InputComponent,
  },
  data() {
    return {
      focused: false,
      input: this.value || '',
    };
  },
  props: {
    step: {
      type: [String, Number],
      default: 'any'
    },
    inputClass: {
      type: String,
      default: 'font-manrope text-base',
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    tooltipCustomStyle: {
      type: Object,
      default: () => ({})
    },
    tooltipText: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: `input-container-id-${Math.random()}`
    },
    bodyClass: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    readonlyAction: {
      type: Boolean,
      default: true,
    },
    noAssistive: {
      type: Boolean,
      default: false,
    },
    enhancerLabel: {
      type: [Boolean, String],
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    clean: {
      type: Boolean,
      default: false,
    },
    value: {},
    label: {
      type: [String, Boolean],
      default: false,
    },
    labelClass: {
      type: String,
      default: 'font-manrope font-medium text-base leading-5 m-0 tracking-[-0.3px] text-[#212529]',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    assistive: {
      type: [String, Boolean],
      default: false,
    },
    error: {
      type: [Boolean, String, Array],
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
    bodyId: {
      type: String,
      default: '',
    },
    sanitize: {
      type: Function,
      default: (v) => v,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reduce: {
      type: Function,
      default: (v) => v,
    },
    delay: {
      type: Number,
      default: 0,
    },
    max: {
      type: [String, Number],
      default: 120,
    },
    charCounter: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: [Boolean, String],
      default: false,
    },
    inputType: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    showCleanButton() {
      return !this.disabled && this.clean && this.value.length;
    },
    invalid() {
      return Boolean(this.error || this.error.length);
    },
  },
  watch: {
    input(input) {
      this.$emit('input', this.reduce(input));
    },
    value(value) {
      this.input = this.reduce(value);
    },
  },
  methods: {
    focus(focus) {
      this.focused = focus;
    },
    blur(blur) {
      this.focused = blur;
    },
    clear() {
      this.$refs.input.clear();
    },
  },
  mounted() {
    this.input = this.reduce(this.value);
  },
};
</script>
